import {
  FormControl,
  FormLabel,
  SelectProps,
  Stack,
  StyleProps,
} from "@chakra-ui/react";
import { SelectControl } from "formik-chakra-ui";
import { ChangeEvent, FunctionComponent, ReactElement } from "react";

type SelectOption = {
  label: string;
  value: string;
  className?: string;
};

type Props = {
  name: string;
  label: string;
  placeholder?: string;
  options: SelectOption[];
  onChange?: (id: string) => void;
  isDisabled?: boolean;
  AlertComponent?: ReactElement;
  defaultValue?: string;
  selectProps?: SelectProps;
} & StyleProps;

/**
 * Convenience wrapper around the Select input.
 * Use this in (Formik) forms.
 */
export const AvelaSelectField: FunctionComponent<Props> = (props) => {
  const {
    name,
    label,
    placeholder,
    options,
    onChange,
    isDisabled,
    AlertComponent,
    defaultValue,
    selectProps,
    ...styleProps
  } = props;

  return (
    <FormControl>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <Stack gap={2}>
        {AlertComponent}
        <SelectControl
          {...styleProps}
          id={name}
          name={name}
          selectProps={{
            placeholder: placeholder,
            defaultValue,
            ...selectProps,
          }}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            onChange?.(event.target.value)
          }
          isDisabled={isDisabled}
        >
          {options.map((option) => {
            const { label, value, className } = option;
            return (
              <option key={value} value={value} className={className}>
                {label}
              </option>
            );
          })}
        </SelectControl>
      </Stack>
    </FormControl>
  );
};
